module.exports = __webpack_public_path__ + "img/owl-logo.3944c6d8.svg";